import { setCsrfToken } from "./csrf";

const AUTH_LOCAL_KEYS = ["username", "role"];
const AUTH_SESSION_KEYS = ["enquiry", "enquiryDraft"];

let redirectingToLogin = false;

/**
 * Clear persisted auth identity so expired sessions cannot keep calling /get_user.
 * Call on logout and on any 401 / session expiry.
 */
export function clearAuthSession({ redirect = false } = {}) {
  try {
    AUTH_LOCAL_KEYS.forEach((key) => localStorage.removeItem(key));
  } catch (_err) {
    try {
      localStorage.clear();
    } catch (_e) {
      /* ignore */
    }
  }

  try {
    AUTH_SESSION_KEYS.forEach((key) => sessionStorage.removeItem(key));
  } catch (_err) {
    /* ignore */
  }

  setCsrfToken("");

  if (!redirect || typeof window === "undefined" || redirectingToLogin) {
    return;
  }

  redirectingToLogin = true;
  const path = window.location.pathname || "/";
  const onLogin = path === "/" || path === "/login" || path.startsWith("/mfa");
  // Remount when already on login so in-memory username/role context state resets
  if (onLogin) {
    window.location.reload();
  } else {
    window.location.href = "/";
  }
}
